const colors = {
  primary: '#000',
  secondary: '#FF0101',
  backgroundLight: '#FBFBFB',
  backgroundDark: '#020203',
  calories: 'red',
  proteines: '#4AB8FF',
  glucides: '#FDCC0C',
  lipides: '#FD5181',
};

export default colors;
